import React from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
    title?: string
}

const PageTitle = ({ title }: Props): React.ReactElement => (
    <Helmet>
        <title>{title ? `${title} - ` : ''}Creative Works Repository</title>
    </Helmet>
)

export default PageTitle
